import { useEffect, useState } from "react";
import { Loader2, Mail } from "lucide-react";
import api from "@/lib/api";
import { AdminTitle } from "@/pages/admin/AdminUI";

const STATUS = ["Unread", "Read", "Replied", "Closed"];
const badge = { Unread: "bg-amber-500/15 text-amber-300", Read: "bg-blue-500/15 text-blue-300", Replied: "bg-emerald-500/15 text-emerald-300", Closed: "bg-slate-500/15 text-slate-400" };

export default function AdminContact() {
  const [items, setItems] = useState(null);

  const load = () => api.get("/admin/contact").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => { await api.put(`/admin/contact/${id}`, { status }); load(); };

  if (items === null) return <div className="flex justify-center py-20"><Loader2 className="animate-spin text-amber-400" size={36} /></div>;

  return (
    <div>
      <AdminTitle title="Contact Messages" />
      <div className="space-y-3">
        {items.length === 0 && <div className="card-lux p-10 text-center"><Mail className="mx-auto text-slate-600 mb-3" size={32} /><p className="text-slate-400">No messages yet.</p></div>}
        {items.map((m) => (
          <div key={m.id} className="card-lux p-5" data-testid={`contact-msg-${m.id}`}>
            <div className="flex items-start justify-between gap-4">
              <div>
                <div className="font-medium text-white">{m.name} <span className="text-slate-500 text-sm font-normal">· {m.email}</span></div>
                <div className="text-sm text-amber-400 mt-0.5">{m.subject || "No subject"}</div>
                <p className="text-sm text-slate-400 mt-2">{m.message}</p>
                <div className="text-xs text-slate-600 mt-2">{(m.created_at || "").slice(0, 16).replace("T", " ")}</div>
              </div>
              <select value={m.status} onChange={(e) => setStatus(m.id, e.target.value)} className={`text-xs font-semibold px-2.5 py-1.5 rounded-lg border-0 ${badge[m.status]}`} data-testid={`contact-status-${m.id}`}>
                {STATUS.map((s) => <option key={s} value={s} className="bg-[#181A20] text-white">{s}</option>)}
              </select>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
